import { defineMessages } from 'react-intl';

export default defineMessages({
  typeAssurance: {
    id: 'signup_auth_contract.type_assurance',
  },
  numPolice: {
    id: 'signup_auth_contract.numero_police',
  },
  requiredField: {
    id: 'required.field',
  },
  title: {
    id: 'addContract.title',
  },
  description: {
    id: 'addContract.description',
  },
  cancel: {
    id: 'addContract.cancel',
  },
  valid: {
    id: 'recovery_forgot_password.insert_new_password.title_button_valid',
  },
  helpMessage: {
    id: 'add_contract.help_message',
  },
  title_success_modal: {
    id: 'title_success_modal',
  },
  description_success_modal: {
    id: 'description_success_modal',
  },
  button_success_modal: {
    id: 'button_success_modal',
  },
});
